import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';
import { GendersModule } from '../genders/genders.module';

import { StudentDetailComponent } from './components/student-detail/student-detail.component';
import { StudentDetailGeneralComponent } from './components/student-detail/components/student-detail-general/student-detail-general.component';
import { StudentDetailSchoolComponent } from './components/student-detail/components/student-detail-school/student-detail-school.component';
import { StudentDetailExtraInfoComponent } from './components/student-detail/components/student-detail-extra-info/student-detail-extra-info.component';
import { StudentEditComponent } from './components/student-edit/student-edit.component';
import { StudentEditGeneralComponent } from './components/student-edit/components/student-edit-general/student-edit-general.component';
import { StudentEditSchoolComponent } from './components/student-edit/components/student-edit-school/student-edit-school.component';
import { StudentEditExtraInfoComponent } from './components/student-edit/components/student-edit-extra-info/student-edit-extra-info.component';
import { StudentSelectorComponent } from './components/student-selector/student-selector.component';
import { StudentSummaryCardComponent } from './components/student-summary-card/student-summary-card.component';

import { StudentEditionComponent } from './pages/student-edition/student-edition.component';
import { StudentInfoComponent } from './pages/student-info/student-info.component';
import { StudentsListComponent } from './pages/students-list/students-list.component';

import { ExtraInfoService } from './services/extra-info.service';
import { StudentService } from './services/student.service';


@NgModule({

    declarations: [

        StudentDetailComponent,
        StudentDetailGeneralComponent,
        StudentEditComponent,
        StudentEditGeneralComponent,
        StudentDetailSchoolComponent,
        StudentDetailExtraInfoComponent,
        StudentEditSchoolComponent,
        StudentEditExtraInfoComponent,
        StudentSelectorComponent,
        StudentSummaryCardComponent,

        StudentEditionComponent,
        StudentInfoComponent,
        StudentsListComponent

    ],

    imports: [

        CommonModule,
        SharedModule,
        TemplateModule,
        GendersModule

    ],

    providers: [

        ExtraInfoService,
        StudentService

    ],

    exports: [

        StudentEditionComponent,
        StudentInfoComponent,
        StudentsListComponent,
        StudentSelectorComponent

    ]

})
export class StudentsModule { }
